import { Box, BoxProps } from '@mui/material';
import { DocumentType } from '../types';

const mimeTypeToDocumentType: Record<string, DocumentType> = {
  'application/pdf': DocumentType.PDF,
  pdf: DocumentType.PDF,
  'application/msword': DocumentType.DOC,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': DocumentType.DOC,
  'application/vnd.ms-excel': DocumentType.XLS,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': DocumentType.XLS,
  'application/vnd.ms-powerpoint': DocumentType.PPT,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': DocumentType.PPT,
  'image/png': DocumentType.IMAGE,
  'image/jpeg': DocumentType.IMAGE,
  'image/jpg': DocumentType.IMAGE,
  'image/gif': DocumentType.IMAGE,
  'image/webp': DocumentType.IMAGE,
  png: DocumentType.IMAGE,
  jpeg: DocumentType.IMAGE,
  jpg: DocumentType.IMAGE,
  gif: DocumentType.IMAGE,
  webp: DocumentType.IMAGE
} as const;

const getDocumentTypeFromMime = (mimeType?: string): DocumentType | undefined => {
  return mimeType ? mimeTypeToDocumentType[mimeType] : undefined;
};

const defaultDocumentIcon = '/icons/default.svg';
const documentTypeIconMap: Record<DocumentType, string> = {
  pdf: '/icons/pdf.svg',
  doc: '/icons/doc.svg',
  xls: '/icons/xls.svg',
  ppt: '/icons/ppt.svg',
  image: '/icons/img.svg'
};

export interface DocumentIconProps extends Omit<BoxProps<'img'>, 'component' | 'src'> {
  type?: DocumentType;
  mimeType?: string;
}

export const DocumentIcon = ({ type, mimeType, ...props }: DocumentIconProps) => {
  const documentType = type || getDocumentTypeFromMime(mimeType);
  const iconSrc = documentType ? documentTypeIconMap[documentType] : defaultDocumentIcon;

  return <Box data-type={documentType} component="img" src={iconSrc} alt={documentType} height="12px" {...props} />;
};
